import { useMutation } from "@tanstack/react-query";
import type { Feedback, FeedbackCreate } from "@spare-cart/contracts/feedback";
import { apiClient } from "@core/api";

export const useSubmitFeedback = () =>
  useMutation({
    mutationFn: (input: FeedbackCreate) => apiClient.post<Feedback>("/feedback", input),
  });
